import gql from 'graphql-tag';

export const CAMPAIGNS_WITH_INSIGHTS_QUERY = gql`
  query CampaignsWithInsightsQuery(
    $filter: CampaignsFilterInput!
    $insightsFilter: AdInsightsFilterInput!
    $aggregationPeriod: String!
    $attributionWindow: AttributionWindowEnum
  ) {
    campaigns(filter: $filter) {
      id
      name
      campaignType
      useCase
      publisherId
      storyAudienceEnable
      budget
      remainingBudget
      maxCpa
      campaignsGoogleConfig {
        campaignType
        dailyBudget
      }

      campaignSpentToday {
        spentToday
        discountSpentToday
      }

      insights(filter: $insightsFilter, aggregationPeriod: $aggregationPeriod, attributionWindow: $attributionWindow) {
        googleInsights {
          clicks
          impressions
          cost
          cpc
          cpm
          ctr
        }
        facebookInsights {
          spendBeforeDiscount
          spendAfterDiscount
          clicks
          impressions
          ctr
          cpm
          cpc
          revenue
          revenueRoi
          profit
          pixelPageViews
          pixelSessions
          pixelAveragePageViewsPerSession
          pixelCostPerPageView
          conversions {
            id
            totalActions
            totalValue
            costPerAction
            roas
            aov
          }
        }
      }
    }
  }
`;
